import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="slide-settings"
export default class extends Controller {
  static targets = [
    "widgetsBtn",
    "widgetsSection",
    "embedsBtn",
    "embedsSection",
    "slideableBtn",
    "slideableSection",
    "stylingBtn",
    "stylingSection",
    "animationBtn",
    "animationSection",
  ]

  toggleWidgets(event) {
    event.preventDefault()
    this.closeAllSections()
    this.widgetsSectionTarget.classList.toggle("hidden")
    this.widgetsBtnTarget.classList.toggle("bg-white")
    this.widgetsBtnTarget.classList.toggle("bg-emerald-200")
  }

  toggleEmbeds(event) {
    event.preventDefault()
    this.closeAllSections()
    this.embedsSectionTarget.classList.toggle("hidden")
    this.embedsBtnTarget.classList.toggle("bg-white")
    this.embedsBtnTarget.classList.toggle("bg-emerald-200")
  }

  toggleSlideable(event) {
    event.preventDefault()
    this.closeAllSections()
    this.slideableSectionTarget.classList.toggle("hidden")
    this.slideableBtnTarget.classList.toggle("bg-white")
    this.slideableBtnTarget.classList.toggle("bg-emerald-200")
  }

  toggleStyling(event) {
    event.preventDefault()
    this.closeAllSections()
    this.stylingSectionTarget.classList.toggle("hidden")
    this.stylingBtnTarget.classList.toggle("bg-white")
    this.stylingBtnTarget.classList.toggle("bg-emerald-200")
  }

  toggleAnimation(event) {
    event.preventDefault()
    this.closeAllSections()
    this.animationSectionTarget.classList.toggle("hidden")
    this.animationBtnTarget.classList.toggle("bg-white")
    this.animationBtnTarget.classList.toggle("bg-emerald-200")
  }

  closeAllSections() {
    // Close all sections
    this.widgetsSectionTarget.classList.add("hidden")
    this.embedsSectionTarget.classList.add("hidden")
    this.slideableSectionTarget.classList.add("hidden")
    this.stylingSectionTarget.classList.add("hidden")
    this.animationSectionTarget.classList.add("hidden")

    // Reset all button colors to white
    this.widgetsBtnTarget.classList.add("bg-white")
    this.widgetsBtnTarget.classList.remove("bg-emerald-200")

    this.embedsBtnTarget.classList.add("bg-white")
    this.embedsBtnTarget.classList.remove("bg-emerald-200")

    this.slideableBtnTarget.classList.add("bg-white")
    this.slideableBtnTarget.classList.remove("bg-emerald-200")

    this.stylingBtnTarget.classList.add("bg-white")
    this.stylingBtnTarget.classList.remove("bg-emerald-200")

    this.animationBtnTarget.classList.add("bg-white")
    this.animationBtnTarget.classList.remove("bg-emerald-200")
  }
}
